<template>
  <div class="list-item template-item">
    <v-list-item-avatar tile v-if="!isMobile">
      <v-img
        height="25px"
        contain
        src="@/assets/svg/publishing-schedule-icon.svg"
      />
    </v-list-item-avatar>
    <v-list-item-content>
      <div class="item-right">
        <div class="description justify-center">
          <div class="d-flex flex-column">
            <span class="font-weight-bold">
              {{ publishingScheduleTemplate.name }}
            </span>
          </div>
        </div>
        <Permissioned section="settings">
          <DotMenuActions
            permission="publishing-schedules.delete"
            :publishingSchedule="publishingScheduleTemplate"
          />
        </Permissioned>
      </div>
    </v-list-item-content>
  </div>
</template>

<script>
import DotMenuActions from "@/views/settings/components/publishing-schedule-templates/components/actions/DotMenuActions";
import Permissioned from "@/components/common/Permissioned";

export default {
  props: {
    publishingScheduleTemplate: {
      type: Object,
      required: true
    }
  },
  components: { DotMenuActions, Permissioned }
};
</script>

<style lang="scss" scope>
.settings-templates {
  .v-list-item {
    min-height: 30px;
    padding: 0 18px;
    .v-list-item__content {
      padding: 4px 10px;
    }
  }
}
</style>
